import { Loader2 } from "lucide-react";
import { T } from "../constants/theme";

export default function LoadingState({ label = "Loading...", compact = false }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 10,
        color: T.muted,
        fontSize: 14,
        padding: compact ? "12px 0" : "40px 0",
      }}
    >
      <Loader2 size={16} className="loading-state-spin" color={T.gold} />
      {label}
      <style>{`
        @keyframes loading-state-spin { to { transform: rotate(360deg); } }
        .loading-state-spin { animation: loading-state-spin .8s linear infinite; }
      `}</style>
    </div>
  );
}
